var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolscubes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 185.049 224.144",
    enableBackground: "new 0 0 185.049 224.144",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000037686098896786026310000016600757720219995279_",
    x: 25.113,
    y: 19.657,
    width: 139.455,
    height: 189.266
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016038749187494518020000012341602295697620913_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000037686098896786026310000016600757720219995279_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000016038749187494518020000012341602295697620913_)",
    fill: "none",
    stroke: "#694A94",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M99.479,176.096l19.1,31.827 M47.412,81.122l-21.299,74.29l16.815,30.991 M140.481,131.531l-75.446-21.636L47.412,81.122 l73.272,21.013L140.481,131.531z M99.479,176.096l-73.271-21.014l21.17-73.839l73.271,21.013L99.479,176.096z M118.579,207.923 l-75.446-21.637l22.025-76.82l75.446,21.637L118.579,207.923z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000016038749187494518020000012341602295697620913_)",
    fill: "none",
    stroke: "#694A94",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M112.538,80.593l-13.776,21.108 M155.075,20.657l-51.257,8.468L89.887,48.574 M151.47,92.993l-8.745-53.033l12.35-19.303 l8.493,51.505L151.47,92.993z M112.538,80.593l-8.493-51.506l50.947-8.416l8.493,51.504L112.538,80.593z M98.762,101.701 l-8.745-53.033l53.004-8.757l8.745,53.033L98.762,101.701z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolscubes);
export default __webpack_public_path__ + "static/media/toolscubes.a7a61b735d40ba8c7bcb54d4a02e7fac.svg";
export { ForwardRef as ReactComponent };